import { createContext, useContext } from "react";

export interface MessageAuthorInfo {
  authorName: string | null;
  authorAvatarUrl: string | null;
}

export interface MessageAuthorContextType {
  getAuthor: (messageId: string) => MessageAuthorInfo | undefined;
}

export const MessageAuthorContext =
  createContext<MessageAuthorContextType | null>(null);

export function useMessageAuthor(
  messageId: string | null | undefined,
): MessageAuthorInfo | undefined {
  const context = useContext(MessageAuthorContext);
  if (!context || !messageId) {
    return undefined;
  }
  return context.getAuthor(messageId);
}
